<template>
  <div
    class="pt-5 m-3 page-header align-items-start min-vh-50 pb-11 border-radius-lg"
    :style="{
      backgroundImage: 'url(' + require('@/assets/img/auth/mi-socio.jpg') + ')',
    }"
  >
    <div class="light-effect"></div>
    <span class="mask bg-gradient-dark opacity-6"></span>
    <div class="container animate-fade-in">
      <div class="row justify-content-center">
        <div class="mx-auto text-center col-lg-5">
          <h1 class="mt-5 mb-2 text-white">MI-chao</h1>
          <p class="text-white text-lead">AIと遊ぼう、新しい世界へ一歩！</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container animate-fade-in">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-5 col-lg-5 col-md-7">
        <div class="card z-index-0">
          <div class="text-center card-header border-bottom pb-2">
            <h5>パスワードの再発行（再設定）</h5>
          </div>
          <div class="card-body">
            <p class="text-start text-sm">
              ※ご登録時のメールアドレスをご入力ください。<br />
              ※新しいバスワードは半角英数記号8～16文字以内でご入力ください。
            </p>
            <div class="form-group">
              <label class="form-label">ログインID</label>
              <soft-input
                id="email"
                type="email"
                placeholder="メールアドレスを入力してください"
                name="email"
              />
            </div>

            <div class="form-group">
              <label class="form-label">パスワード</label>
              <soft-input
                id="password"
                type="password"
                placeholder="半角英数記号8～16文字"
                name="password"
              />
              <soft-input
                id="password"
                type="password"
                placeholder="確認のためもう一度入力してください"
                name="password"
              />
            </div>

            <div class="text-center my-4">
              <soft-button
                variant="gradient"
                color="warning"
                full-width
                @click="handleComplete"
                ><i class="fa fa-edit me-1"></i>登録
              </soft-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="min-vh-60 d-flex flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :md="9" :lg="7" :xl="6">
          <CCard class="mx-4">
            <CCardHeader>
              <h1>Change Password</h1>
            </CCardHeader>
            <CCardBody class="p-4">
              <CInputGroup class="mb-3">
                <CInputGroupText>
                  <CIcon icon="cil-lock-locked" />
                </CInputGroupText>
                <CFormInput
                  type="password"
                  placeholder="Current Password"
                  v-model="oldPassword"
                />
              </CInputGroup>

              <CInputGroup class="mb-3">
                <CInputGroupText>
                  <CIcon icon="cil-lock-locked" />
                </CInputGroupText>
                <CFormInput
                  type="password"
                  placeholder="New Password"
                  v-model="newPassword"
                />
              </CInputGroup>

              <CRow align="right">
                <CCol :xs="6"></CCol>
                <CCol :xs="6" align="right">
                  <CButton
                    color="info"
                    @click="onChangePassword"
                    class="white-text"
                  >
                    Change Password
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
            <div
              v-if="successMessage"
              class="alert alert-success"
              align="center"
            >
              {{ successMessage }}
            </div>
            <div v-if="errorMessage" class="alert-failure" align="right">
              {{ errorMessage }}
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
  <app-footer />
</template>

<script>
import {
  CCard,
  CCardBody,
  CContainer,
  CRow,
  CCol,
  CInputGroup,
  CInputGroupText,
  CFormInput,
  CButton,
} from '@coreui/vue'
import { CIcon } from '@coreui/icons-vue'
import HTTPService from '../services/HTTPService'
import SoftButton from '@/components/SoftButton.vue'
import AppFooter from '@/components/PageLayout/Auth/Footer.vue'
import SoftInput from '@/components/SoftInput.vue'

export default {
  name: 'ChangePassword',
  components: {
    SoftInput,
    AppFooter,
    SoftButton,
    CCard,
    CCardBody,
    CContainer,
    CRow,
    CCol,
    CInputGroup,
    CInputGroupText,
    CFormInput,
    CButton,
    CIcon,
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      successMessage: '',
      errorMessage: '',
    }
  },
  methods: {
    async onChangePassword() {
      // Call the change_password endpoint with the old and new passwords

      try {
        const password = this.oldPassword
        const newPassword = this.newPassword
        const response = await HTTPService.changePassword(password, newPassword)

        //console.log(response)

        if (response.status === 200) {
          // handle success, e.g. display a success message
          this.successMessage = 'Password Changed Successfully!'
          this.errorMessage = ''
        }
      } catch (error) {
        this.errorMessage = 'Failed to change Password:' + error.response
        this.successMessage = ''
        //console.log(error.response)
      }
    },
    OnCancel() {
      this.$router.push({ name: 'Upload' })
    },
  },
}
</script>
<style>
.alert-failure {
  background-color: #f8d7da;
  color: #721c24;
  border-color: #f5c6cb;
  align: 'center';
}
</style>
